import styled from "styled-components";
import { COLORS, responsive } from "../../../../styles/constants.style";

export const InvoicingDetailsWrapper = styled.div`
  padding: 0px 0px 0px 16px;
  ${responsive.MOBILE`
      padding: 0 16px 0px 16px;
    `}

  .notes-input {
    .MuiInputBase-root {
      height: 100px;
      background: ${COLORS.cirrus_black1};
      padding: 0px;
    }
  }
`;
